import m from "./../../../dist/es2015/locales/sk_SK.js";
export const am5locales_sk_SK = m;